import { useFieldArray, useFormContext } from 'react-hook-form';

import { FaPlus } from 'react-icons/fa6';
import { HiTrash } from 'react-icons/hi';

import { Button } from 'components/Button';
import { AutocompleteInput, Input } from 'components/Form';

const WarehouseLocationItem = ({ name_prefix, index, remove }) => {
    const {
        formState: { errors },
        register,
        setValue,
        watch,
    } = useFormContext();

    return (
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Input
                type='text'
                placeholder='Warehouse Name'
                label={`${name_prefix}.${index}.name`}
                register={register}
                watch={watch}
                errors={errors}
                size='sm'
                narrow
                hideErrorMessage
            />

            <AutocompleteInput
                id={`${name_prefix}.${index}.location`}
                value={watch(`${name_prefix}.${index}.location`) || ''}
                setValue={setValue}
                register={register}
                errors={errors}
                watch={watch}
                placeholder='Warehouse Location'
                size='sm'
                hideErrorMessage
                hideEndIcon
                formStyling
            />

            <Button
                uitype='icon'
                radius='round'
                color='secondary-dark'
                onClick={(event) => {
                    event.preventDefault();
                    remove(index);
                }}
            >
                <HiTrash title='Delete warehouse' />
            </Button>
        </div>
    );
};

const WarehouseLocations = ({ name_prefix }) => {
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: name_prefix,
    });

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                }}
            >
                {fields.map((item, index) => (
                    <WarehouseLocationItem
                        key={item.id}
                        name_prefix={name_prefix}
                        index={index}
                        remove={remove}
                    />
                ))}
            </div>

            <Button
                uitype='ghost'
                color='primary-dark'
                size='xs'
                onClick={(event) => {
                    event.preventDefault();
                    append({});
                }}
                style={{ marginTop: '8px' }}
            >
                <FaPlus /> Add warehouse
            </Button>
        </div>
    );
};

export { WarehouseLocations };
